import React from "react"
import PropTypes from "prop-types"
import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import i18n from "i18n"

const Loading = ({ message }) => {
  const spinner = (
    <CircularProgress aria-label={i18n.t("Cargando...")} color="primary" />
  )

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        flex: "1 1 auto",
        minHeight: 0,
        alignSelf: "stretch",
        boxSizing: "border-box",
      }}
    >
      {message ? (
        <Stack alignItems="center" spacing={2}>
          {spinner}
          <Typography
            variant="body2"
            component="p"
            sx={{ color: "text.secondary", textAlign: "center", m: 0 }}
          >
            {message}
          </Typography>
        </Stack>
      ) : (
        spinner
      )}
    </Box>
  )
}

Loading.propTypes = {
  message: PropTypes.string,
}

export default Loading
